import OrdersLogDataTable from "../../../../components/dataTable/tables/canteen/OrdersLogDataTable";

function OrdersLogPageView() {
  return <OrdersLogDataTable />;
}

export default OrdersLogPageView;
